<template>
  <router-view v-slot="{ Component, route }">
    <template v-if="Component">
      <transition name="fade" mode="out-in">
        <component :is="Component" :key="route.fullPath" />
      </transition>
    </template>
  </router-view>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent ( {
  name: "App"
})
</script>

<style lang="scss">

/** Lato **/
/* lato-300 - latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 300;
  src: local(''),
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Flato-v23-latin-300.woff2?alt=media&token=032bda87-c41f-44f1-9510-47b43ff3884f') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Flato-v23-latin-300.woff?alt=media&token=b7bfaf3f-2928-47ef-a41e-a365d1a2d01e') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* lato-regular - latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  src: local(''),
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Flato-v23-latin-regular.woff2?alt=media&token=061302be-b08e-470b-a544-a96b4c24f02f') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Flato-v23-latin-regular.woff?alt=media&token=c11a403e-4633-41f7-88d2-bec4c41652b2') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* lato-700 - latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  src: local(''),
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Flato-v23-latin-700.woff2?alt=media&token=5f01ca09-0cbd-4546-9b9f-591f32fb6d57') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Flato-v23-latin-700.woff?alt=media&token=37858b88-0d8c-4633-a9c4-c1e66886a557') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

/** Amatic **/
/* amatic-sc-regular - latin */
@font-face {
  font-family: 'Amatic SC';
  font-style: normal;
  font-weight: 400;
  src: local(''),
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Famatic-sc-v24-latin-regular.woff2?alt=media&token=34d21947-2a7d-458e-aeef-8b4c8e12af4e') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Famatic-sc-v24-latin-regular.woff?alt=media&token=72a116ac-cab3-464c-b8b1-0b5e39d126a1') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* amatic-sc-700 - latin */
@font-face {
  font-family: 'Amatic SC';
  font-style: normal;
  font-weight: 700;
  src: local(''),
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Famatic-sc-v24-latin-700.woff2?alt=media&token=2dea6578-2f9d-4fd6-9d87-c8a45683b452') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  url('https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2Famatic-sc-v24-latin-700.woff?alt=media&token=d7cd2edb-de0e-431c-9410-c5b743e84abc') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

@font-face {
  font-family: "Renner";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("Renner"), url("https://firebasestorage.googleapis.com/v0/b/escape-if-you-can-01.appspot.com/o/fonts%2FRennerSmall.ttf?alt=media&token=733f56a1-c42e-4f04-bde7-39277230b1dd") format("truetype");
}

/** Normalize **/
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/** Normalize End **/

html, body {
  width: 100%;
  height: 100%;
  //min-width: 100vh;
  min-height: 100vh;
  margin: 0;
}

body {
  position: relative;
  background-color: #ffffff;
  font-family: Lato, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $primary;
}

#app {
  width: 100%;
  height: 100%;
}

h1, h2 {
  text-transform: uppercase;
  color: $primary;
}

/** Form styling **/
*:focus {
  outline: none;
}

select, input[type='text'], input[type='password'], button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  outline: 0;
}

textarea {
  width: 100%;
  height: 100px;
  padding: 12px 12px;
  box-sizing: border-box;
  border: 2px solid $gray-lighter;
  border-radius: 4px;
  background-color: $gray-light;
  font-size: 16px;
  resize: none;
}

button {
  font-family: Lato, Helvetica, Arial, sans-serif;
  font-weight: bold;
  cursor: pointer;
  background: none;
  color: $primary;

  &:hover:after {
    box-shadow: 0px 0px 8px 1px #2c3e5070;
  }
}

.container-wrapper {
  width: 100%;
  height: 100%;
  max-width: 1024px;
  margin: 0 auto;
}

.container-center {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hotspot {
  cursor: pointer;
  font-size: 0;
}

.nobr {
  white-space: nowrap;
}

/** animations **/
.mode-fade-enter-active, .mode-fade-leave-active {
  transition: opacity .5s ease
}

.mode-fade-enter-from, .mode-fade-leave-to {
  opacity: 0
}

/** Button **/
.btn {
  border-color: transparent;
  border-radius: 0.25rem;
  border-width: 1px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  line-height: 1.375;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: rgba(255, 255, 255, 1);
  background-color: $redpurple-900;

  &:hover {
    background-color: $redpurple-700;
  }

  &:disabled {
    background-color: $redpurple-500;
    cursor: default;
  }
}

/** Logo Background-Image **/
.escape-if-you-can-logo {
  display: block;
  width: 104px;
  height: 65px;
  margin: 2rem auto;
  background-image: url("data:image/svg+xml;base64,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");
  background-size: contain;
  background-repeat: no-repeat;
}

/** Page transition **/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}


.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
